module.exports = __webpack_public_path__ + "static/media/profile.663f2f29.png";